import { getMobileMatchMediaEmitter, subscribe } from '@1inch-community/core/lit-utils';
import { html, LitElement } from 'lit';
import { skip, switchMap } from 'rxjs';
export class NotificationsBaseContainerElement extends LitElement {
    constructor() {
        super();
        this.notifications = [];
        this.animationInProgress = false;
        this.animationStateQueue = [];
        this.fullView = false;
        this.countShortView = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        subscribe(this, [
            getMobileMatchMediaEmitter().pipe(skip(1), switchMap(() => this.controller.closeNotifications())),
        ], { requestUpdate: false });
    }
    setController(controller) {
        this.controller = controller;
    }
    setAllNotifications(notifications) {
        if (this.animationInProgress) {
            this.animationStateQueue.push(notifications);
            return;
        }
        this.notifications = notifications;
        if (!this.fullView && this.countShortView < this.maxShorthandView) {
            this.countShortView++;
        }
        this.requestUpdate();
    }
    animationStartHandler() {
        this.animationInProgress = true;
    }
    animationCompleteHandler() {
        this.animationInProgress = false;
        const newState = this.animationStateQueue.shift();
        if (newState) {
            this.notifications = newState;
            this.requestUpdate();
        }
    }
    openAll() {
        this.onShowAll();
    }
    onShowAll() {
        this.fullView = true;
        this.requestUpdate();
    }
    async closeNotification(id) {
        await this.controller.removeNotification(id);
    }
    makeNotificationTemplate(record) {
        const template = html `${record.element}`;
        if (record.config.customTemplate)
            return html `${template}`;
        return html ` <div class="notification-template">${template}</div> `;
    }
    getSortedNotifications() {
        const result = this.notifications;
        if (this.fullView) {
            return result;
        }
        return [...result.slice(0, this.countShortView)];
    }
}
//# sourceMappingURL=notifications-base-container.element.js.map